import {
  withTranslation,
} from 'react-i18next';

import CrewmemberAccessTokenFieldsView from './CrewmemberAccessTokenFieldsView';

const TranslatedComponent = withTranslation()(CrewmemberAccessTokenFieldsView);

const Component = TranslatedComponent;

export default Component;
